import { Component, type ErrorInfo, type ReactNode } from 'react'

import { Button } from '@/components/ui'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

/** Última linha de defesa contra erro de renderização — evita tela branca. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Sem serviço de observabilidade ainda; console é suficiente por ora.
    console.error('Erro não tratado na UI:', error, info.componentStack)
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div className="grid min-h-dvh place-items-center bg-bg p-6">
        <div className="max-w-sm space-y-3 text-center">
          <h1 className="text-lg font-semibold text-fg">Algo deu errado</h1>
          <p className="text-sm text-fg-muted">
            Ocorreu um erro inesperado. Recarregue a página para continuar.
          </p>
          <Button onClick={() => window.location.reload()}>Recarregar</Button>
        </div>
      </div>
    )
  }
}
